export const pricesData = [
  {
    route: 'Prague Airport → City Centre',
    standard_eur: 30,
    standard_czk: 750,
    comfort_eur: 34,
    comfort_czk: 844,
    premium_eur: 49,
    premium_czk: 1219,
    minivan_eur: 38,
    minivan_czk: 938,
    premium_minivan_eur: 49,
    premium_minivan_czk: 1219,
  },
  {
    route: 'City Centre → Prague Airport',
    standard_eur: 30,
    standard_czk: 750,
    comfort_eur: 34,
    comfort_czk: 844,
    premium_eur: 49,
    premium_czk: 1219,
    minivan_eur: 38,
    minivan_czk: 938,
    premium_minivan_eur: 49,
    premium_minivan_czk: 1219,
  },
  {
    route: 'Prague Airport → Karlovy Vary',
    standard_eur: 130,
    standard_czk: 3250,
    comfort_eur: 146,
    comfort_czk: 3656,
    premium_eur: 211,
    premium_czk: 5281,
    minivan_eur: 163,
    minivan_czk: 4063,
    premium_minivan_eur: 211,
    premium_minivan_czk: 5281,
  },
  {
    route: 'Karlovy Vary → Prague Airport',
    standard_eur: 130,
    standard_czk: 3250,
    comfort_eur: 146,
    comfort_czk: 3656,
    premium_eur: 211,
    premium_czk: 5281,
    minivan_eur: 163,
    minivan_czk: 4063,
    premium_minivan_eur: 211,
    premium_minivan_czk: 5281,
  },
  {
    route: 'Prague Airport → Dresden (Germany)',
    standard_eur: 220,
    standard_czk: 5500,
    comfort_eur: 248,
    comfort_czk: 6188,
    premium_eur: 358,
    premium_czk: 8938,
    minivan_eur: 275,
    minivan_czk: 6875,
    premium_minivan_eur: 358,
    premium_minivan_czk: 8938,
  },
  {
    route: 'Prague Airport → Vienna (Austria)',
    standard_eur: 280,
    standard_czk: 7000,
    comfort_eur: 315,
    comfort_czk: 7875,
    premium_eur: 455,
    premium_czk: 11375,
    minivan_eur: 350,
    minivan_czk: 8750,
    premium_minivan_eur: 455,
    premium_minivan_czk: 11375,
  },
  {
    route: 'Prague Airport → Český Krumlov',
    standard_eur: 190,
    standard_czk: 4750,
    comfort_eur: 214,
    comfort_czk: 5344,
    premium_eur: 309,
    premium_czk: 7719,
    minivan_eur: 238,
    minivan_czk: 5938,
    premium_minivan_eur: 309,
    premium_minivan_czk: 7719,
  },
  {
    route: 'Prague Airport → Plzeň',
    standard_eur: 100,
    standard_czk: 2500,
    comfort_eur: 113,
    comfort_czk: 2813,
    premium_eur: 163,
    premium_czk: 4063,
    minivan_eur: 125,
    minivan_czk: 3125,
    premium_minivan_eur: 163,
    premium_minivan_czk: 4063,
  },
  {
    route: 'Prague Airport → Liberec',
    standard_eur: 120,
    standard_czk: 3000,
    comfort_eur: 135,
    comfort_czk: 3375,
    premium_eur: 195,
    premium_czk: 4875,
    minivan_eur: 150,
    minivan_czk: 3750,
    premium_minivan_eur: 195,
    premium_minivan_czk: 4875,
  },
  {
    route: 'Prague Airport → Pardubice',
    standard_eur: 140,
    standard_czk: 3500,
    comfort_eur: 158,
    comfort_czk: 3938,
    premium_eur: 228,
    premium_czk: 5688,
    minivan_eur: 175,
    minivan_czk: 4375,
    premium_minivan_eur: 228,
    premium_minivan_czk: 5688,
  },
  {
    route: 'Prague Airport → Hradec Králové',
    standard_eur: 150,
    standard_czk: 3750,
    comfort_eur: 169,
    comfort_czk: 4219,
    premium_eur: 244,
    premium_czk: 6094,
    minivan_eur: 188,
    minivan_czk: 4688,
    premium_minivan_eur: 244,
    premium_minivan_czk: 6094,
  },
  {
    route: 'Prague Airport → Ostrava',
    standard_eur: 400,
    standard_czk: 10000,
    comfort_eur: 450,
    comfort_czk: 11250,
    premium_eur: 650,
    premium_czk: 16250,
    minivan_eur: 500,
    minivan_czk: 12500,
    premium_minivan_eur: 650,
    premium_minivan_czk: 16250,
  },
  {
    route: 'Prague Airport → Salzburg (Austria)',
    standard_eur: 340,
    standard_czk: 8500,
    comfort_eur: 383,
    comfort_czk: 9563,
    premium_eur: 553,
    premium_czk: 13813,
    minivan_eur: 425,
    minivan_czk: 10625,
    premium_minivan_eur: 553,
    premium_minivan_czk: 13813,
  },
  {
    route: 'Prague Airport → Munich (Germany)',
    standard_eur: 370,
    standard_czk: 9250,
    comfort_eur: 416,
    comfort_czk: 10406,
    premium_eur: 601,
    premium_czk: 15031,
    minivan_eur: 463,
    minivan_czk: 11563,
    premium_minivan_eur: 601,
    premium_minivan_czk: 15031,
  },
  {
    route: 'Prague Airport → Bratislava (Slovakia)',
    standard_eur: 270,
    standard_czk: 6750,
    comfort_eur: 304,
    comfort_czk: 7594,
    premium_eur: 439,
    premium_czk: 10969,
    minivan_eur: 338,
    minivan_czk: 8438,
    premium_minivan_eur: 439,
    premium_minivan_czk: 10969,
  },
  {
    route: 'Prague Airport → Hallstatt (Austria)',
    standard_eur: 420,
    standard_czk: 10500,
    comfort_eur: 473,
    comfort_czk: 11813,
    premium_eur: 683,
    premium_czk: 17063,
    minivan_eur: 525,
    minivan_czk: 13125,
    premium_minivan_eur: 683,
    premium_minivan_czk: 17063,
  },
  {
    route: 'Prague Airport → Graz (Austria)',
    standard_eur: 380,
    standard_czk: 9500,
    comfort_eur: 428,
    comfort_czk: 10688,
    premium_eur: 618,
    premium_czk: 15438,
    minivan_eur: 475,
    minivan_czk: 11875,
    premium_minivan_eur: 618,
    premium_minivan_czk: 15438,
  },
  {
    route: 'Prague Airport → Nuremberg (Germany)',
    standard_eur: 320,
    standard_czk: 8000,
    comfort_eur: 360,
    comfort_czk: 9000,
    premium_eur: 520,
    premium_czk: 13000,
    minivan_eur: 400,
    minivan_czk: 10000,
    premium_minivan_eur: 520,
    premium_minivan_czk: 13000,
  },
  {
    route: 'Prague Airport → Regensburg (Germany)',
    standard_eur: 290,
    standard_czk: 7250,
    comfort_eur: 326,
    comfort_czk: 8156,
    premium_eur: 471,
    premium_czk: 11781,
    minivan_eur: 363,
    minivan_czk: 9063,
    premium_minivan_eur: 471,
    premium_minivan_czk: 11781,
  },
  {
    route: 'Prague Airport → Linz (Austria)',
    standard_eur: 300,
    standard_czk: 7500,
    comfort_eur: 338,
    comfort_czk: 8438,
    premium_eur: 488,
    premium_czk: 12188,
    minivan_eur: 375,
    minivan_czk: 9375,
    premium_minivan_eur: 488,
    premium_minivan_czk: 12188,
  },
  {
    route: 'Prague Airport → Krakow (Poland)',
    standard_eur: 350,
    standard_czk: 8750,
    comfort_eur: 394,
    comfort_czk: 9844,
    premium_eur: 569,
    premium_czk: 14219,
    minivan_eur: 438,
    minivan_czk: 10938,
    premium_minivan_eur: 569,
    premium_minivan_czk: 14219,
  },
  {
    route: 'Prague Airport → Budapest (Hungary)',
    standard_eur: 450,
    standard_czk: 11250,
    comfort_eur: 506,
    comfort_czk: 12656,
    premium_eur: 731,
    premium_czk: 18281,
    minivan_eur: 563,
    minivan_czk: 14063,
    premium_minivan_eur: 731,
    premium_minivan_czk: 18281,
  },
  {
    route: 'Prague Airport → Wrocław (Poland)',
    standard_eur: 280,
    standard_czk: 7000,
    comfort_eur: 315,
    comfort_czk: 7875,
    premium_eur: 455,
    premium_czk: 11375,
    minivan_eur: 350,
    minivan_czk: 8750,
    premium_minivan_eur: 455,
    premium_minivan_czk: 11375,
  },
  {
    route: 'Prague Airport → Český Ráj',
    standard_eur: 110,
    standard_czk: 2750,
    comfort_eur: 124,
    comfort_czk: 3094,
    premium_eur: 179,
    premium_czk: 4469,
    minivan_eur: 138,
    minivan_czk: 3438,
    premium_minivan_eur: 179,
    premium_minivan_czk: 4469,
  },
  {
    route: 'Prague Airport → Kutná Hora',
    standard_eur: 90,
    standard_czk: 2250,
    comfort_eur: 101,
    comfort_czk: 2531,
    premium_eur: 146,
    premium_czk: 3656,
    minivan_eur: 113,
    minivan_czk: 2813,
    premium_minivan_eur: 146,
    premium_minivan_czk: 3656,
  },
  {
    route: 'Prague Airport → Telč',
    standard_eur: 180,
    standard_czk: 4500,
    comfort_eur: 203,
    comfort_czk: 5063,
    premium_eur: 293,
    premium_czk: 7313,
    minivan_eur: 225,
    minivan_czk: 5625,
    premium_minivan_eur: 293,
    premium_minivan_czk: 7313,
  },
  {
    route: 'Prague Airport → Děčín (Bohemian Switzerland)',
    standard_eur: 130,
    standard_czk: 3250,
    comfort_eur: 146,
    comfort_czk: 3656,
    premium_eur: 211,
    premium_czk: 5281,
    minivan_eur: 163,
    minivan_czk: 4063,
    premium_minivan_eur: 211,
    premium_minivan_czk: 5281,
  },
];
